import * as angular from "angular";
import * as _ from "lodash";
import { User } from "../models/user.model";
import { UserDataProvider } from "./user.dp";

export class AdminDataProvider {
    private localStorage: any;
    private user: User;
    public columns: object;
    public defaultColumns = {
        campaigns: [
            {
                id: "campaignid",
                name: "ID",
                selected: true,
                disabled: true,
            },
            {
                id: "campaignname",
                name: "Account",
                selected: true,
                disabled: true,
            },
            {
                id: "owner",
                name: "Owner",
                selected: true,
                disabled: true,
            },
            // Stripe or Xero, whichever bills the account (AV-17974).
            {
                id: "billing",
                name: "Billing",
                selected: true,
                disabled: true,
            },
            // Stripe subscription status or Xero standing; opens the history dialog.
            {
                id: "payments",
                name: "Payment status",
                selected: true,
                disabled: true,
            },
            {
                id: "campaignkind",
                name: "Type",
                selected: true,
            },
            {
                id: "campaignstatus",
                name: "Status",
                selected: true,
            },
            {
                id: "campaignregion",
                name: "Region",
                selected: true,
            },
            {
                id: "campaigncreationdatetime",
                name: "Created",
                selected: true,
            },
            {
                id: "creator",
                name: "Creator",
                selected: true,
            },
            {
                id: "userslimit",
                name: "Standard Users",
                selected: true,
            },
            {
                id: "customfieldslimit",
                name: "Custom Fields",
                selected: true,
            },
            {
                id: "houseoccupantslimit",
                name: "Contacts",
                selected: true,
            },
            // Usage the support team sorts by (AV-17963); contacts already has
            // a column, so only these two are new.
            {
                id: "houses",
                name: "Houses",
                selected: false,
            },
            {
                id: "interactions",
                name: "Interactions",
                selected: false,
            },
            {
                id: "planhouseoccupantslimit",
                name: "Plan Contacts",
                selected: true,
            },
            {
                id: "geocodinglimit",
                name: "Geocoded Houses",
                selected: true,
            },
        ],
        users: [
            {
                id: "uid",
                name: "ID",
                selected: true,
                disabled: true,
            },
            {
                id: "name",
                name: "Name",
                selected: true,
                disabled: true,
            },
            {
                id: "presence",
                name: "Presence",
                selected: true,
            },
            {
                id: "udevice",
                name: "Device",
                selected: true,
            },
            {
                id: "app_version",
                name: "App version",
                selected: true,
            },
            {
                id: "contact_details",
                name: "Email / phone",
                selected: true,
            },
            {
                id: "uaccountstatus",
                name: "Status",
                selected: true,
            },
            {
                id: "ujoindate",
                name: "Joined",
                selected: true,
            },
        ],
        // AV-17958 Activity lens: same accounts, usage columns. The two
        // range-labelled columns get " · 7d" etc. appended in the template.
        campaignsActivity: [
            { id: "campaignid", name: "ID", selected: true, disabled: true },
            {
                id: "campaignname",
                name: "Account",
                selected: true,
                disabled: true,
            },
            { id: "a_interactions", name: "Interactions", selected: true },
            { id: "a_logins", name: "Logins", selected: true },
            { id: "a_activeusers", name: "Active users", selected: true },
            { id: "a_contacts", name: "Contacts added", selected: true },
            { id: "a_lastactivity", name: "Last activity", selected: true },
            { id: "a_trend", name: "Trend", selected: true },
            { id: "a_spark", name: "28 days", selected: true },
        ],
        organisationsActivity: [
            { id: "oid", name: "ID", selected: true, disabled: true },
            {
                id: "oname",
                name: "Organisation",
                selected: true,
                disabled: true,
            },
            { id: "a_accounts", name: "Accounts", selected: true },
            { id: "a_interactions", name: "Interactions", selected: true },
            { id: "a_logins", name: "Logins", selected: true },
            { id: "a_activeusers", name: "Active users", selected: true },
            { id: "a_contacts", name: "Contacts added", selected: true },
            { id: "a_lastactivity", name: "Last activity", selected: true },
            { id: "a_trend", name: "Trend", selected: true },
            { id: "a_spark", name: "28 days", selected: true },
        ],
        organisations: [
            {
                id: "oid",
                name: "ID",
                selected: true,
                disabled: true,
            },
            {
                id: "oname",
                name: "Organisation",
                selected: true,
                disabled: true,
            },
            {
                // Renders oleader's name and email, which the export calls Owner.
                id: "creator",
                name: "Owner",
                selected: true,
                disabled: true,
            },
            {
                id: "billing",
                name: "Billing",
                selected: true,
                disabled: true,
            },
            {
                id: "payments",
                name: "Payment status",
                selected: true,
                disabled: true,
            },
            // AV-18115: how many accounts sit under the organisation.
            // Clickable - opens the list so an admin can join one.
            {
                id: "accounts",
                name: "Accounts",
                selected: true,
            },
            {
                id: "otimestamp",
                name: "Created",
                selected: true,
            },
            {
                id: "ostatus",
                name: "Status",
                selected: true,
            },
            {
                id: "oregion",
                name: "Region",
                selected: true,
            },
            {
                id: "userslimit",
                name: "Standard Users",
                selected: true,
            },
            {
                id: "customfieldslimit",
                name: "Custom Fields",
                selected: true,
            },
            {
                id: "houseoccupantslimit",
                name: "Contacts",
                selected: true,
            },
            // Usage the support team sorts by (AV-17963).
            {
                id: "houses",
                name: "Houses",
                selected: false,
            },
            {
                id: "interactions",
                name: "Interactions",
                selected: false,
            },
            {
                id: "geocodinglimit",
                name: "Geocoded Houses",
                selected: true,
            },
            // Xero contact for the organisation (AV-17974).
        ],
    };

    /**
     * Resolves once the admin's server-side choices (pins, columns) have been
     * applied over the browser copy. Lists that read pins before drawing wait
     * on it; everything else reads the browser copy and catches up.
     */
    public ready: Promise<void>;

    constructor(
        localStorageService: any,
        UserDataProvider: UserDataProvider,
        private $http: any,
        $q: any
    ) {
        this.localStorage = localStorageService;
        this.user = UserDataProvider.getActiveUser();
        this.ready = this.loadPreferences($q);
    }

    // ---------- Server-side choices (AV-17963) ----------
    // Pins and column layouts are kept on the user row (shared by both
    // regions) so they follow the admin between browsers and consoles. The
    // browser copy stays as the working set and as the fallback when the
    // request fails.

    private loadPreferences($q: any): Promise<void> {
        return this.$http
            .get("/v2/admin/preferences")
            .then((response: any): void => {
                const data = response && response.data && response.data.data;
                if (!data) return;
                const info = this.user.getLocalStorage() || {};
                if (data.pins) info.pins = data.pins;
                if (data.columns && Object.keys(data.columns).length) {
                    info.columns = angular.extend(
                        {},
                        info.columns || {},
                        data.columns
                    );
                }
                this.user.localInfo = info;
                this.user.saveLocalStorage();
                if (this.columns) this.setColumns();
            })
            .catch((): void => undefined);
    }

    /** Sends one or both slices; the browser copy is already updated by the caller. */
    savePreferences(patch: { pins?: any; columns?: any }): void {
        this.$http
            .put("/v2/admin/preferences", patch)
            .catch((): void => undefined);
    }

    /**
     * Defaults with the admin's saved "selected" choices applied by column id,
     * so adding, removing or reordering defaults never scrambles saved choices
     * (the old index-based merge did).
     */
    setColumns(): void {
        this.localStorage = this.user.getLocalStorage();
        const stored = (this.localStorage && this.localStorage.columns) || {};
        const live: any = this.columns || {};
        for (const tab of Object.keys(this.defaultColumns)) {
            const saved = _.keyBy(stored[tab] || [], "id");
            // Build once, then update in place: the lists hold a reference to
            // this array, so replacing it would leave them on the old columns
            // until the next page load.
            if (!live[tab]) {
                live[tab] = this.defaultColumns[tab].map((column: any) => ({
                    ...column,
                }));
            }
            live[tab].forEach((column: any) => {
                const choice = saved[column.id];
                if (choice && !column.disabled) {
                    column.selected = !!choice.selected;
                }
            });
            // The dialog lets admins drag columns into an order; honour it,
            // with any column the saved list has never seen kept at the end.
            const order: string[] = (stored[tab] || []).map((c: any) => c.id);
            if (order.length) {
                live[tab].sort((a: any, b: any) => {
                    const ai = order.indexOf(a.id);
                    const bi = order.indexOf(b.id);
                    return (
                        (ai === -1 ? order.length : ai) -
                        (bi === -1 ? order.length : bi)
                    );
                });
            }
            // Locked columns (disabled in the picker) sit where the defaults
            // put them, whatever order an older saved layout carried.
            const defaults: any[] = this.defaultColumns[tab];
            const movable = live[tab].filter((c: any) => !c.disabled);
            const merged: any[] = movable.slice();
            defaults.forEach((d: any, index: number) => {
                if (!d.disabled) return;
                const col = live[tab].filter((c: any) => c.id === d.id)[0];
                if (col) merged.splice(Math.min(index, merged.length), 0, col);
            });
            live[tab].length = 0;
            merged.forEach((c: any) => live[tab].push(c));
        }
        this.columns = live;
    }

    /**
     * Trend chip counts for the Activity lens, per tab, written by the list
     * that loaded the rows and read by the chip row (AV-17958).
     */
    /**
     * AV-18115: one number per quick-filter chip, keyed by tab then by the
     * chip's value. The Activity lens fills it with trend counts, the
     * Directory with status/platform counts, and "__total" carries the count
     * behind the All chip.
     */
    public chipCounts: { [tab: string]: { [value: string]: number } } = {};

    /** @deprecated AV-18115 - kept so existing readers keep working. */
    public get trendCounts(): { [tab: string]: { [trend: string]: number } } {
        return this.chipCounts;
    }
    public set trendCounts(value: {
        [tab: string]: { [trend: string]: number };
    }) {
        this.chipCounts = value;
    }
    /** Column-set key for a tab in a lens: "campaigns" or "campaignsActivity". */
    static columnsKey(tab: string, lens: string | undefined): string {
        return lens === "activity" &&
            (tab === "campaigns" || tab === "organisations")
            ? tab + "Activity"
            : tab;
    }

    getColumns(): any {
        this.setColumns();
        return this.columns;
    }

    // ---------- Pinned rows (AV-17963) ----------
    // Per admin, alongside the column choices; see savePreferences().

    static readonly PIN_LIMIT = 20;

    getPins(kind: "campaigns" | "organisations"): number[] {
        const info = this.user.getLocalStorage() || {};
        const pins = (info.pins && info.pins[kind]) || [];
        return pins
            .map((id: any) => Number(id))
            .filter((id: number) => !isNaN(id));
    }

    isPinned(
        kind: "campaigns" | "organisations",
        id: number | string
    ): boolean {
        return this.getPins(kind).indexOf(Number(id)) !== -1;
    }

    /**
     * Flips a pin. Returns the new state, or "limit" when the cap is hit and
     * nothing changed.
     */
    togglePin(
        kind: "campaigns" | "organisations",
        id: number | string
    ): "pinned" | "unpinned" | "limit" {
        const numericId = Number(id);
        const pins = this.getPins(kind);
        const index = pins.indexOf(numericId);
        let state: "pinned" | "unpinned";
        if (index !== -1) {
            pins.splice(index, 1);
            state = "unpinned";
        } else {
            if (pins.length >= AdminDataProvider.PIN_LIMIT) {
                return "limit";
            }
            pins.push(numericId);
            state = "pinned";
        }
        const info = this.user.getLocalStorage() || {};
        info.pins = info.pins || {};
        info.pins[kind] = pins;
        this.user.localInfo = info;
        this.user.saveLocalStorage();
        this.savePreferences({ pins: info.pins });
        return state;
    }
}

angular
    .module("vcDataProvider")
    .service("AdminDataProvider", AdminDataProvider);
